<template>
  <div class="calendar">

    <!-- [ Header ] start -->
    <Header :open="open" @showMenu="showMenu" @hideMenu="hideMenu" />
    <!-- [ Header ] end -->

    <div class="content">
      <!-- [ Menu ] start -->
      <Menu :open="open" @companyName="companyName"/>
      <!-- [ Menu ] end -->

      <div class="wrap">

        <!-- [ Controls ] start -->
        <div class="wrap__controls">

          <div class="controls">
            <h2>Controls</h2>
            <h4>Period UOM</h4>

            <el-radio-group style="width: 100%; margin-bottom: 20px;"  v-model="displayPeriodUom" size="mini">
              <el-radio-button label="month"></el-radio-button>
              <el-radio-button label="week"></el-radio-button>
              <el-radio-button label="year"></el-radio-button>
            </el-radio-group>

            <!-- <el-select style="width: 100%; margin-bottom: 20px;" v-model="displayPeriodUom" placeholder="Select" size="mini">
              <el-option label="month" value="month"></el-option>
              <el-option label="week" value="week"></el-option>
              <el-option label="year" value="year"></el-option>
            </el-select> -->

            <!-- <h4>Starting day of the week</h4>
            <el-select style="width: 100%; margin-bottom: 20px;" v-model="startingDayOfWeek" placeholder="Select">
              <el-option label="Sunday" value="0"></el-option>
              <el-option label="Monday" value="1"></el-option>
              <el-option label="Tuesday" value="2"></el-option>
              <el-option label="Wednesday" value="3"></el-option>
              <el-option label="Thursday" value="4"></el-option>
              <el-option label="Friday" value="5"></el-option>
              <el-option label="Saturday" value="6"></el-option>
            </el-select> -->
          </div>

          <div class="add">
            <h2>Add event</h2>
            <el-form @submit.prevent.native="submitForm('form')" :model="form" status-icon :rules="rules" ref="form" label-position="left" label-width="100px" class="demo-ruleForm">
              <el-form-item prop="title" label="Title">
                <el-input style="width: 100%" placeholder="Title" size="mini" v-model="form.title"></el-input>
              </el-form-item>
              <el-form-item prop="startDate" label="Start Date">
                <el-date-picker style="width: 100%"
                                format="d MMM yy"
                                v-model="form.startDate"
                                type="date" size="mini"
                                placeholder="Pick a day"
                                value-format="ddMMyyyy"></el-date-picker>
                <!-- <el-input type="date" placeholder="Start Date" size="mini" v-model="form.startDate"></el-input> -->
              </el-form-item>
              <el-form-item prop="endDate" label="End Date">
                <el-date-picker style="width: 100%"
                                format="d MMM yy"
                                v-model="form.endDate"
                                type="date" size="mini"
                                placeholder="Pick a day"
                                value-format="ddMMyyyy">
                </el-date-picker>
                <!-- <el-input type="date" placeholder="End Date" size="mini" v-model="form.endDate"></el-input> -->
              </el-form-item>
              <el-form-item label-width="0" class="modal__btn">
                <el-button @click="submitForm('form')" class="modal__btn" type="primary" plain size="mini">Add event</el-button>
              </el-form-item>
            </el-form>
          </div>

        </div>
        <!-- [ Controls ] end -->

        <!-- [ Calendar ] start -->
        <div class="wrap__parent">

          <calendar-view
            :events="list"
            :show-date="showDate"
            :displayPeriodUom="displayPeriodUom"
            :startingDayOfWeek="startingDayOfWeek"
            class="theme-default holiday-us-traditional holiday-us-official">
            <calendar-view-header
              slot="header"
              slot-scope="t"
              :header-props="t.headerProps"
              @input="setShowDate" />
          </calendar-view>

        </div>
        <!-- [ Calendar ] end -->

      </div>
    </div>

  </div>
</template>

<script>
  import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
	// The next two lines are processed by webpack. If you're using the component without webpack compilation,
	// you should just create <link> elements for these. Both are optional, you can create your own theme if you prefer.
	require("vue-simple-calendar/static/css/default.css")
	require("vue-simple-calendar/static/css/holidays-us.css")
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'
  import axios from 'axios'
  export default {
    name: 'Calendar',
    components: {
      // Header,
      // Menu,
      CalendarView,
			CalendarViewHeader,
    },
    created() {
      this.$store.dispatch('getCalendarList')
    },
    computed: {
      list() {
        return this.$store.getters.getCalendarList || []
      },
    },
    data() {
      return {
        open: false,
        companyNameSelect: '',

        // controls
        showDate: new Date(),

        displayPeriodUom: 'month',
        startingDayOfWeek: 1,

        events: [
          {
            id: "0",
            startDate: new Date(),
            endDate: new Date(),
            title: "Test Task",
            classes: "orange",
          },
        ],

        // add
        form: {
          title: '',
          startDate: null,
          endDate: null,
        },
        rules: {
          title: [{
            required: true,
            message: 'Title is required',
            trigger: 'blur'
          }],
          startDate: [{
            required: true,
            message: 'Start Date is required',
            trigger: 'blur'
          }],
          endDate: [{
            required: true,
            message: 'End Date is required',
            trigger: 'blur'
          }],
        },
      }
    },
    methods: {
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      submitForm(form) {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            console.log('submit!!');
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/calendar/create?companyId=${this.$route.query.companyId}`, {
                title: this.form.title,
                startDate: this.form.startDate,
                endDate: this.form.endDate,
              })
              .then(response => {
                // console.log('---', response.data);
                // this.$refs.invite.close();
                loader.hide()
                this.$store.dispatch('getCalendarList')
                this.notification("Success", "Add event", "success");
                this.$refs['form'].resetFields();
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },

      setShowDate(d) {
				this.showDate = d;
			},
    },
  }
</script>

<style lang="scss" scoped>
  .calendar {
    background: #f2f4f7;
    height: 100vh;
  }

  .content {
    display: flex;
    height: 100vh;
    padding-top: 50px;
  }

  // [ Wrapper ] start
  .wrap {
    display: flex;
    width: 100%;
    padding: 20px 10px 10px 10px;

    &__controls {
      width: 20%;
      padding: 0 10px 10px 0;
      .controls {
        background: #fff;
        border-radius: 6px;
        box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
        color: #4a4a4a;
        padding: 10px;
        margin-bottom: 10px;
      }
      .add {
        background: #fff;
        border-radius: 6px;
        box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
        color: #4a4a4a;
        padding: 10px;
        margin-bottom: 10px;
      }
      h2 {
        margin: 0 0 20px 0;
        text-align: center;
      }
      h4 {
        margin: 0 0 10px 0;
      }
    }
    &__parent {
      display: flex;
      flex-direction: column;
      width: 80%;
      padding: 0 0 10px 0;
    }
  }
  // [ Wrapper ] end

  // [ Modal ] start
  .modal {
    &__title {
      text-align: center;
    }
    &__btn {
      text-align: right;
    }
  }
  // [ Modal ] end
</style>
